export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: number;
  imageSeq: string;
  imagePrompt: string;
}

export const articles: Article[] = [
  {
    slug: 'huanqi-xinli-tanxi',
    title: '换妻行为的深层心理驱动力探究',
    excerpt: '为什么有人会选择换妻？本文从进化心理学、情感依恋理论和社会交换理论三个维度，剖析换妻行为背后的复杂心理机制。',
    content: `<p>换妻行为作为一种非传统的性实践，其心理驱动力远比表面看起来更为复杂。理解这些深层动因，有助于我们以更客观、更全面的视角看待这一现象。</p>

<h2>进化心理学的视角</h2>
<p>从进化心理学角度来看，人类男性普遍存在性多样化渴望，这一倾向在进化历程中曾被自然选择所强化——广泛的性接触增加了基因传播的机会。而女性参与换妻的动机则更为多元，包括寻求优质基因、获取资源、以及通过性选择测试伴侣承诺度等。</p>
<p>值得注意的是，现代社会中的换妻行为已经远远超越了单纯的生物本能驱动。参与者往往具有较高的教育水平和认知能力，能够对自身行为进行理性反思。</p>

<h2>依恋理论与情感需求</h2>
<p>根据依恋理论，安全型依恋的夫妻更有可能在换妻活动中获得积极体验。他们对彼此有着充分的信任基础，将换妻视为共同探索而非情感背叛。</p>
<p>研究表明，许多参与者将换妻描述为一种"共享的冒险"，这种共同经历反而强化了伴侣间的情感纽带。这与大众对换妻必然破坏关系的刻板印象形成了鲜明对比。</p>

<h2>社会交换理论的解释</h2>
<p>社会交换理论认为，人在关系中不断进行成本与收益的评估。对于换妻参与者而言，新鲜感、刺激感、自我认知的拓展构成了主要收益；而嫉妒情绪、时间精力投入、社交风险则是主要成本。</p>
<p>当参与者感受到收益大于成本，且有明确的退出机制和协商规则时，他们更倾向于持续参与。这解释了为什么成功的换妻实践通常建立在极为细致的沟通和规则制定之上。</p>

<h2>自我探索与身份认同</h2>
<p>不可忽视的是，许多参与者将换妻视为一种自我探索的途径。性欲望和性幻想的多元化表达，在安全、自愿、平等的框架下，可以成为一种积极的自我认知拓展方式。</p>
<p>部分参与者报告称，通过换妻经历，他们对自己的性取向、情感模式和关系偏好有了更深刻的理解，这种自我认知的提升甚至改善了他们在日常生活其他方面的表现。</p>`,
    category: 'xinli-dongji',
    author: '李思远',
    publishDate: '2026-07-20',
    readTime: 8,
    imageSeq: 'article-psychology-01',
    imagePrompt: 'Minimalist abstract illustration of two intertwined silhouettes forming a balanced composition, warm earthy tones with terracotta and cream, soft gradients, contemplative atmosphere, editorial quality, no explicit content, artistic and tasteful representation of human connection and psychology',
  },
  {
    slug: 'kaifang-guanxi-qinggan-guanli',
    title: '开放关系中的情感管理：嫉妒与信任的博弈',
    excerpt: '嫉妒是开放关系中最常见的情绪挑战。本文提供实用的情感管理策略，帮助伴侣在探索换妻文化的同时维护核心关系的稳定。',
    content: `<p>在换妻活动中，情感管理是最具挑战性的课题之一。尤其是嫉妒——这种被许多人视为"关系毒药"的情绪，在开放关系的语境下需要被重新审视和处理。</p>

<h2>重新认识嫉妒</h2>
<p>嫉妒并非一种"错误"的情感。从进化心理学角度看，嫉妒是一种保护性机制，旨在维护重要的情感资源和关系投入。问题不在于嫉妒本身的存在，而在于我们如何应对它。</p>
<p>许多成功的换妻参与者将嫉妒视为一种信号——它提示我们需要关注某些未满足的情感需求，或者某些需要重新协商的关系边界。</p>

<h2>建立情感安全网</h2>
<p>情感安全网的建立需要从多个层面进行：首先是自我觉察能力的培养，能够准确识别和命名自己的情绪状态；其次是伴侣间开放、诚实的情感沟通渠道；最后是明确的"安全词"或"暂停机制"，当任何一方感到不适时可以立即中止活动。</p>
<p>定期进行"情感检查"（emotional check-in）是许多换妻夫妻的固定习惯。这种结构化对话让双方有机会表达感受、调整规则、重新确认彼此的承诺。</p>

<h2>信任的建立与维护</h2>
<p>信任不是一种静止的状态，而是一个动态的过程。在换妻的语境下，信任体现在多个维度：对伴侣承诺的信任、对安全规则遵守的信任、对诚实沟通的信任。</p>
<p>值得强调的是，换妻行为中的信任往往需要比传统一夫一妻关系更加坚实。因为参与者将自己置于更为脆弱的情感位置，对信任的要求自然更高。</p>

<h2>实际应对策略</h2>
<p>以下是经过实践验证的情感管理策略：建立清晰的参与规则并严格遵守；保持核心关系中的专属仪式感（如换妻后的单独约会时间）；学会区分"不舒服"和"不可接受"——前者是成长的机会，后者是需要调整的信号；在必要时寻求专业心理咨询师的帮助。</p>`,
    category: 'xinli-dongji',
    author: '王雅文',
    publishDate: '2026-07-15',
    readTime: 7,
    imageSeq: 'article-emotion-01',
    imagePrompt: 'Abstract minimalist composition of two separate but connected organic shapes in warm amber and soft beige tones, representing emotional balance and trust, clean white background with subtle texture, editorial art quality, peaceful and contemplative mood',
  },
  {
    slug: 'xingjiankang-yufang-zhinan',
    title: '换妻活动中的性健康防护完全指南',
    excerpt: '性健康是换妻活动安全进行的基石。本文涵盖STI检测频率、屏障保护方法、疫苗接种建议、以及活动前后的健康管理全流程。',
    content: `<p>性健康防护是换妻活动中不可妥协的基本原则。无论参与者的信任程度有多高，科学、系统、严格的健康管理措施都是确保所有参与者身心安全的必要条件。</p>

<h2>STI检测：频率与项目</h2>
<p>建议所有活跃的换妻参与者每三个月进行一次全面的性传播感染（STI）检测。检测项目应至少包括：HIV、梅毒、淋病、衣原体、乙型肝炎、丙型肝炎、生殖器疱疹（HSV-1/2）以及HPV筛查。</p>
<p>重要的是，参与者应该在每次与新伴侣接触前出示近期的检测报告，并且明确了解检测的"窗口期"概念——某些感染在暴露后数周甚至数月才能被检测出来。</p>

<h2>屏障保护的规范使用</h2>
<p>安全套是换妻活动中最基本的保护工具。建议使用高品质的乳胶或聚氨酯安全套，并确保正确佩戴和更换。对于口交行为，也应使用口腔保护膜（dental dam）或剪开的安全套作为屏障。</p>
<p>特别需要注意的是，在不同伴侣之间切换时，必须更换新的安全套，避免交叉感染。同时，润滑剂应选择水基或硅基产品，避免油基润滑剂对乳胶安全套的破坏。</p>

<h2>疫苗接种</h2>
<p>建议所有参与者接种以下疫苗：乙型肝炎疫苗（三针完整接种）、HPV疫苗（九价）、甲型肝炎疫苗。这些疫苗可以显著降低某些可通过性接触传播的感染风险。</p>

<h2>活动后的健康观察</h2>
<p>活动后建议进行为期2-4周的健康观察。如出现任何异常症状（如分泌物异常、皮疹、发热、淋巴结肿大等），应立即就医并诚实告知医生相关暴露史。早期发现、早期治疗对于大多数STI的预后至关重要。</p>`,
    category: 'anquan-shouze',
    author: '张明辉',
    publishDate: '2026-07-18',
    readTime: 6,
    imageSeq: 'article-health-01',
    imagePrompt: 'Clean minimalist medical safety concept illustration, abstract geometric shield shape in warm sage green tones, soft cream background, representing protection and wellness, clinical yet artistic, no medical equipment shown, pure abstract design',
  },
  {
    slug: 'yinsi-baohu-shuzi-anquan',
    title: '数字时代的隐私保护：换妻参与者的信息安全指南',
    excerpt: '在数字足迹无处不在的今天，隐私保护是换妻参与者的生命线。本文提供从通讯加密到社交媒体管理的全方位隐私保护方案。',
    content: `<p>对于换妻参与者而言，隐私泄露不仅意味着尴尬，更可能带来职业风险、家庭危机甚至法律问题。在数字化时代，系统的隐私保护策略已经成为参与者必备的生存技能。</p>

<h2>通讯加密</h2>
<p>日常交流应使用端到端加密的即时通讯工具，如Signal或Telegram的密聊模式。这些工具确保只有通信双方能够阅读消息内容，即便是服务提供商也无法解密。</p>
<p>避免使用微信等可能受到监控的通讯平台讨论敏感话题。如果必须使用，应使用代号和隐晦表达，避免直接提及真实姓名、地点和细节。</p>

<h2>社交媒体管理</h2>
<p>严格区分公开身份和圈内身份。建立独立的社交媒体账户用于换妻社群交流，使用完全不同的用户名、邮箱和头像。确保两个身份之间没有任何交叉引用。</p>
<p>在公开社交平台上，避免发布可能暴露行踪的实时定位信息。关闭社交平台的位置标记功能和"附近的人"功能。定期检查并清理可能无意中泄露身份信息的旧帖。</p>

<h2>数据存储安全</h2>
<p>敏感照片和视频应存储在加密的云存储服务中，而非手机本地相册。使用独立的、设有强密码的账户管理这些内容。定期审查并删除不再需要的敏感数据。</p>
<p>与伴侣协商明确关于照片和视频的规则：是否可以拍摄、如何存储、何时删除、是否有权分享。这些规则应白纸黑字写下来并获得双方确认。</p>

<h2>线下活动的隐私保护</h2>
<p>选择活动地点时应确保远离居住区域和工作区域。避免选择可能被熟人认出的场所。使用化名进行线下交流，直到建立了足够的信任基础。</p>
<p>活动结束后不要交换过多的个人真实信息，遵循"需要知道"原则——只分享活动必需的信息，而非全部个人信息。</p>`,
    category: 'anquan-shouze',
    author: '陈思涵',
    publishDate: '2026-07-22',
    readTime: 9,
    imageSeq: 'article-privacy-01',
    imagePrompt: 'Abstract digital privacy concept illustration, layered geometric shapes in warm taupe and soft olive tones, representing data protection and security layers, minimalist clean design, professional editorial style, serene and trustworthy atmosphere',
  },
  {
    slug: 'zhongguo-huanqi-falv-jiexi',
    title: '中国法律框架下的换妻行为边界深度解析',
    excerpt: '在中国现行法律体系下，换妻行为涉及聚众淫乱罪、传播性病罪等多重法律风险。本文基于现行法律条文与司法实践进行客观分析。',
    content: `<p>换妻行为在中国法律框架下面临着复杂的法律灰色地带。本部分内容旨在基于现行法律条文和公开司法案例进行客观分析，帮助读者了解可能面临的法律风险。</p>

<h2>聚众淫乱罪的法律界定</h2>
<p>《中华人民共和国刑法》第三百零一条规定了聚众淫乱罪，对首要分子或多次参加者可处以五年以下有期徒刑、拘役或者管制。该罪名的构成要件包括"聚众"（通常指三人以上）和"淫乱活动"两个核心要素。</p>
<p>司法实践中，当换妻活动涉及三人以上同时参与，或具有公开性、组织性特征时，可能被认定为聚众淫乱。需要特别指出的是，即使是完全自愿的成人之间、在私密空间内进行的活动，如果符合"聚众"特征，理论上仍存在法律风险。</p>

<h2>传播性病罪的相关规定</h2>
<p>《刑法》第三百六十条规定，明知自己患有严重性病仍进行卖淫、嫖娼的，可构成传播性病罪。虽然换妻行为不涉及金钱交易，但如果参与者明知自身携带性传播感染而故意隐瞒并参与活动，可能面临民事侵权责任乃至刑事责任。</p>

<h2>治安管理处罚法的适用</h2>
<p>《治安管理处罚法》第六十六条关于卖淫嫖娼的规定一般不适用于无金钱交易的换妻行为。但若活动中涉及金钱或其他财物交换，可能被认定为变相的卖淫嫖娼。</p>

<h2>与境外司法管辖的比较</h2>
<p>相比之下，许多西方国家（如美国多数州、英国、澳大利亚等）对成人之间自愿的、私密的性行为持更为宽容的法律态度。例如，美国联邦最高法院在Lawrence v. Texas案中确立了成人自愿私密性行为的宪法保护。但即使在法律相对宽松的法域，涉及多人、公共场所或商业化的行为仍可能面临法律限制。</p>`,
    category: 'falv-bianjie',
    author: '林正阳',
    publishDate: '2026-07-25',
    readTime: 10,
    imageSeq: 'article-law-01',
    imagePrompt: 'Abstract legal concept illustration, balanced scales motif rendered as minimalist geometric forms in warm earth tones and soft grey, representing justice and legal boundaries, clean professional aesthetic, sophisticated editorial design quality',
  },
  {
    slug: 'huanqi-quanshu-yu-liyi',
    title: '换妻圈术语词典：从入门到精通的文化密码',
    excerpt: '每个亚文化群体都有其独特的语言体系。本文系统梳理换妻社群中的核心术语、黑话和表达方式，帮助新人快速融入社群文化语境。',
    content: `<p>任何成熟的亚文化群体都会发展出独特的语言系统，这既是身份认同的标志，也是信息加密的手段。换妻社群也不例外，掌握这些术语是融入社群的第一步。</p>

<h2>基础身份术语</h2>
<p><strong>夫妻/情侣（Couple）：</strong>社群中最基本的参与单位，指共同参与换妻活动的一对伴侣。<strong>单男（Single Male）：</strong>单独参与的男性，通常需要经过严格筛选。<strong>单女（Single Female）：</strong>单独参与的女性，在社群中相对稀缺。<strong>验证夫妻（Verified Couple）：</strong>指经过社群认证、确认真实身份和意愿的伴侣。</p>

<h2>活动类型术语</h2>
<p><strong>同房不换（Same Room No Swap）：</strong>两对伴侣在同一空间内各自进行性活动，但不交换伴侣。这是很多新人的入门方式。<strong>软交换（Soft Swap）：</strong>指伴侣交换后仅限于非插入式性行为。<strong>完全交换（Full Swap）：</strong>伴侣完全交换，包括插入式性行为。<strong>多对多（Orgy/Group）：</strong>多对伴侣同时参与的自由形式活动。</p>

<h2>情感规则术语</h2>
<p><strong>只看不碰（Look Don't Touch）：</strong>允许观察但不允许肢体接触。<strong>安全词（Safe Word）：</strong>预先约定的停止信号。<strong>界限（Boundaries）：</strong>参与者明确划定的不可逾越的行为边界。<strong>事后关怀（Aftercare）：</strong>活动结束后伴侣间的安抚和情感确认时间。</p>

<h2>社群组织术语</h2>
<p><strong>局（Party/Gathering）：</strong>指有组织的换妻聚会活动。<strong>主持人（Host）：</strong>活动组织者和场地提供者。<strong>门槛（Vetting/Screening）：</strong>新成员进入社群前的审核程序。<strong>圈内（In the Lifestyle）：</strong>指已经参与换妻活动的人群。</p>`,
    category: 'shequn-wenhua',
    author: '赵雨桐',
    publishDate: '2026-07-28',
    readTime: 5,
    imageSeq: 'article-dictionary-01',
    imagePrompt: 'Abstract typographic pattern illustration with layered translucent geometric shapes in warm terracotta and cream tones, representing language and culture, minimalist bookish aesthetic, clean editorial design, sophisticated intellectual atmosphere',
  },
  {
    slug: 'chuci-tiyan-zhunbei',
    title: '初次换妻体验：从心理建设到实操准备的全流程',
    excerpt: '第一次换妻体验的成败往往取决于前期准备的质量。本文覆盖心理建设、伴侣沟通、活动选择、安全措施等各环节的实操建议。',
    content: `<p>对于任何考虑踏入换妻世界的伴侣来说，第一次体验至关重要。充分的准备工作不仅能够最大化积极体验的可能性，更能有效降低潜在的情感伤害和关系风险。</p>

<h2>心理建设阶段</h2>
<p>在实际行动之前，建议伴侣双方花至少3-6个月的时间进行心理建设。这包括：各自单独反思参与动机，确保不是出于讨好对方或逃避关系问题；一起阅读相关书籍和资料，建立共同的认知基础；通过角色扮演和情景想象，测试各自的情感反应。</p>
<p>如果在这一阶段发现任何一方存在明显的犹豫、焦虑或抵触情绪，应该暂缓推进，给予更多时间进行讨论和适应。</p>

<h2>伴侣沟通框架</h2>
<p>建议采用结构化的沟通方式，包括：明确列出各自的"愿望清单"和"禁区清单"；讨论并记录对"成功体验"的定义和预期；约定活动中的非语言沟通信号（如眼神、手势）；确定活动结束后的情感处理流程。</p>
<p>特别重要的是讨论"如果感觉不好怎么办"——确保双方都清楚，任何一方可以在任何时候无条件叫停，且不会因此受到责备。</p>

<h2>选择适合的入门方式</h2>
<p>对于大多数新人，建议从最低强度的方式开始，逐步升级：同房不换 → 软交换 → 完全交换。这种渐进式的方式让伴侣有充分的时间适应和调整，降低情感冲击的强度。</p>
<p>选择活动对象时，建议优先选择有经验的夫妻作为引导者，他们往往更能理解和尊重新人的节奏和界限。</p>

<h2>活动后的情感处理</h2>
<p>活动结束后24-48小时是情感波动的高峰期。建议安排充足的独处时间，进行坦诚的情感交流。如果出现负面情绪，不要急于下结论说"我们不合适"，而是将其视为需要进一步沟通和调整的信号。</p>`,
    category: 'jingyan-fenxiang',
    author: '周子涵',
    publishDate: '2026-07-30',
    readTime: 8,
    imageSeq: 'article-first-time-01',
    imagePrompt: 'Abstract illustration of a gentle sunrise horizon with soft warm gradients from cream to terracotta, representing new beginnings and anticipation, minimalist composition, serene and hopeful atmosphere, editorial art quality',
  },
  {
    slug: 'guoji-huanqi-falv-duibi',
    title: '全球视野下的换妻法律规制比较研究',
    excerpt: '从美国到欧洲，从日本到东南亚，不同国家和地区对换妻行为的法律态度差异巨大。本文提供全球主要法域的对比分析。',
    content: `<p>换妻行为的法律地位在全球范围内呈现出极大的差异性，从完全合法到刑事重罪，这种差异反映了不同社会在性伦理、宗教传统和个人自由之间的不同平衡方式。</p>

<h2>北美地区</h2>
<p>美国大多数州对成人之间自愿的、私密的换妻行为持宽容态度，受宪法第十四修正案的实质性正当程序保护。但部分保守州仍有通奸罪（adultery）的法律条文（虽然极少执行）。加拿大的法律体系与美国类似，强调成人自愿和私密性作为合法性的前提条件。</p>

<h2>欧洲地区</h2>
<p>大多数西欧国家（如英国、法国、德国、荷兰、西班牙等）的法律对成人之间自愿的换妻行为不设刑事限制。荷兰和德国甚至有合法运营的换妻俱乐部。东欧国家的法律态度则更为保守，部分国家仍保有较严格的性道德立法。</p>

<h2>亚洲地区</h2>
<p>亚洲各国对换妻行为的法律态度差异最为显著。日本对成人自愿的性行为持相对宽松态度，但社会舆论极为保守。中国如前所述存在聚众淫乱罪的法律风险。新加坡、马来西亚等国有严格的道德治安法规。泰国虽然在性产业方面较为开放，但对组织性活动仍有法律限制。</p>

<h2>中东与非洲地区</h2>
<p>受伊斯兰教法或保守宗教传统影响，这些地区的法律对任何婚外性行为均持严格禁止态度，换妻行为可能面临极其严厉的刑事处罚，包括长期监禁甚至死刑。</p>`,
    category: 'falv-bianjie',
    author: '林正阳',
    publishDate: '2026-08-01',
    readTime: 7,
    imageSeq: 'article-global-law-01',
    imagePrompt: 'Abstract world map concept rendered as interconnected geometric nodes in warm amber and olive tones on cream background, representing global perspectives, minimalist data visualization aesthetic, sophisticated editorial design',
  },
  {
    slug: 'huanqi-shequn-shengtao',
    title: '换妻社群的内部生态：从线上社区到线下聚会',
    excerpt: '换妻社群有着复杂而有序的内部组织结构。本文揭秘从线上论坛、私密群组到线下聚会、主题派对的全生态链运作模式。',
    content: `<p>换妻社群并非一团散沙，而是形成了相对成熟和有序的内部组织结构。了解这个生态系统，有助于理解换妻文化如何在主流社会的缝隙中得以持续和发展。</p>

<h2>线上社区生态</h2>
<p>线上社区是换妻社群的基础设施。主要包括：专业社交平台（如海外知名的SDC、Kasidie、SLS等）、即时通讯群组（Telegram、Signal等加密通讯工具上的私密群组）、以及各类论坛和博客。</p>
<p>这些线上空间承担着多重功能：信息交流（活动信息、安全提醒、经验分享）、新成员筛选（通过验证机制筛选真实用户）、社交网络构建（帮助地理位置相近的用户建立联系）。</p>

<h2>线下活动形态</h2>
<p>线下活动形式多样，常见的有：小型私人聚会（Meet & Greet），通常4-10人在餐厅或酒吧进行非性接触的社交；主题派对（Themed Party），有特定着装要求和活动流程的较大规模聚会；俱乐部（Club），会员制的固定活动场所，提供更为专业和规范的设施。</p>

<h2>审核与信任机制</h2>
<p>大多数正规社群都有严格的审核机制：身份验证（通过视频通话确认本人身份）、关系验证（确认是真实伴侣而非商业目的）、推荐人制度（需要现有成员的推荐和担保）。</p>
<p>这些机制虽然繁琐，但有效过滤了不良参与者，维护了社群的安全基础和信任文化。</p>

<h2>社群规范的演进</h2>
<p>随着社群的发展，一套不成文但被广泛遵守的规范逐渐形成：尊重边界是所有互动的第一原则；禁止未经同意的肢体接触和拍摄；保护彼此隐私是基本道德底线；老成员有义务引导和帮助新人。</p>`,
    category: 'shequn-wenhua',
    author: '赵雨桐',
    publishDate: '2026-08-02',
    readTime: 6,
    imageSeq: 'article-community-01',
    imagePrompt: 'Abstract network visualization with interconnected organic nodes in warm earth tones and soft olive, representing community connections, minimalist geometric design, sophisticated editorial quality, harmonious composition',
  },
  {
    slug: 'tuiqun-sikao-zongjie',
    title: '退出换妻圈：一段旅程的结束与人生的反思',
    excerpt: '不是所有的换妻参与者都会终身停留在这个圈子里。本文收集多位"过来人"的退圈心路历程，呈现关于成长、选择与告别的真实故事。',
    content: `<p>退出换妻圈（圈内常称"退役"或"上岸"）是一种常见的现象，但很少被公开讨论。每位退出者都有自己的理由和故事，这些经验对于正在考虑参与或已经在圈内的人来说，都具有宝贵的参考价值。</p>

<h2>常见的退圈原因</h2>
<p>根据社群内的非正式调查，最常见的退圈原因包括：情感疲劳——长期维持多重情感边界消耗大量心理能量；关系重心转移——希望将更多精力投入到核心伴侣关系或家庭生活中；年龄增长——身体机能的变化使得某些活动不再适合；价值观变化——对性和关系的理解随着年龄和阅历增长而改变；以及社会压力——担心秘密被曝光对职业和家庭造成影响。</p>

<h2>退圈的心理历程</h2>
<p>退圈往往不是一蹴而就的决定，而是一个渐进的过程。许多过来人描述这个历程类似于"重新认识自己"：从最初的不安和怀旧，到中期的适应和重新定位，再到最终的坦然接受和感恩。</p>
<p>部分退出者表示，他们在退圈后更加珍惜核心伴侣关系，认为换妻经历帮助他们更清楚地认识到自己真正想要的是什么。</p>

<h2>对圈内关系的处理</h2>
<p>退出后如何处理与圈内朋友的关系是一个微妙的课题。有些人选择彻底切断联系，以求"重新开始"；有些人则保留了少数深度友谊，将其转化为不涉及性的普通社交关系。</p>
<p>大多数过来人建议：尊重自己的节奏，不必迫于压力维持不想维持的关系；真诚表达感谢和告别，而非突然消失；给自己和伴侣充足的过渡时间。</p>`,
    category: 'jingyan-fenxiang',
    author: '周子涵',
    publishDate: '2026-08-03',
    readTime: 7,
    imageSeq: 'article-exit-01',
    imagePrompt: 'Abstract sunset horizon illustration with warm fading gradients from amber to soft cream, representing closure and reflection, minimalist landscape composition, peaceful and contemplative mood, editorial art quality',
  },
  {
    slug: 'qingxu-bianjie-jianli',
    title: '建立健康的情感边界：换妻关系中的自我保护',
    excerpt: '情感边界是换妻活动参与者最重要的心理护盾。本文提供系统化的情感边界建立方法，帮助参与者在享受探索的同时保护自己的情感健康。',
    content: `<p>情感边界（Emotional Boundaries）是换妻活动中至关重要的概念。它指的是个体在情感层面为自己设立的"保护线"，划定哪些情感投入是可以接受的，哪些是需要保留的。</p>

<h2>理解情感边界的重要性</h2>
<p>在换妻活动中，性与情感的分离是一项核心技能——但这项技能不是天生的，需要刻意练习和持续维护。健康的情感边界不是冰冷的墙壁，而是一扇可以自主控制开关的门。</p>
<p>缺乏情感边界的常见后果包括：对活动对象产生超出预期的情感依赖、在核心关系中产生过度的比较心理、活动后的情感低落期延长等。</p>

<h2>情感边界的建立方法</h2>
<p>建立情感边界可以从以下几个方面着手：明确区分"性吸引"和"情感依恋"，学会识别两者的不同信号；设定清晰的行为界限（如限制私下单独联系的频率和深度、避免过度分享个人生活中的脆弱面）；培养"正念"能力，在活动过程中保持对自身情感状态的觉察。</p>
<p>与核心伴侣明确讨论并达成共识：哪些情感表达是双方都能接受的，哪些触碰到了关系的"红线"。</p>

<h2>情感边界的维护</h2>
<p>边界建立后需要持续的维护和调整。定期与伴侣进行"边界检查"对话；当发现自己出现过度情感投入的迹象时及时自我调整；学会在必要时对活动对象坦诚表达"我需要一些空间"。</p>
<p>记住：健康的情感边界不是一成不变的，它可以根据你的成长、关系的深化和生活阶段的变化而灵活调整。关键是这种调整是有意识的、经过沟通的，而非被动的、防御性的。</p>`,
    category: 'anquan-shouze',
    author: '王雅文',
    publishDate: '2026-08-04',
    readTime: 6,
    imageSeq: 'article-boundary-01',
    imagePrompt: 'Abstract composition of soft geometric layers with distinct but permeable boundaries in warm sienna and cream tones, representing emotional boundaries, minimalist design, calm and balanced atmosphere, editorial art quality',
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((article) => {
  articleMap[article.slug] = article;
});

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getFeaturedArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, count);
}